'use client';

import React, {Suspense, type FC} from 'react';
import {LayoutPlatform} from '@/_application/themes/kidsplaza-spring/layouts/components/layout-platform';
import {type AppLayoutProps} from '@/_application/core/types';

export const HomeLayoutClient: FC<AppLayoutProps> = ({children, layoutData, isMobile = false}) => {
    return (
        <Suspense>
            <LayoutPlatform isMobile={isMobile} variables={layoutData}>
                {children}
            </LayoutPlatform>
        </Suspense>
    );
};
